import { render, staticRenderFns } from "./ArrivalChecklistComponent.vue?vue&type=template&id=8a198756&scoped=true&"
import script from "./ArrivalChecklistComponent.vue?vue&type=script&lang=js&"
export * from "./ArrivalChecklistComponent.vue?vue&type=script&lang=js&"
import style0 from "./ArrivalChecklistComponent.vue?vue&type=style&index=0&id=8a198756&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a198756",
  null
  
)

export default component.exports